import axios from 'axios';
import type { Project } from '@/models/project';

class ProjectWebservice {
    public load() {
        return axios.get<Project[]>('/projects/byUser');
    }

    public loadOneByUser(projectId: number) {
        return axios.get<Project>('/projects/oneByUser', {
            params: {
                projectId,
            },
        });
    }

    public loadAll() {
        return axios.get<Project[]>('/projects');
    }

    public loadAllByCompany() {
        return axios.get<Project[]>('/projects/byCompany');
    }

    public getById(projectId: number) {
        return axios.get<Project>('/projects/getById', {
            params: {
                projectId,
            },
        });
    }

    public store(project: Project) {
        return axios.post('/projects/store', {
            title: project.title,
            description: project.description,

            trades: project.hasOwnProperty('trades') ? project.trades.map((trade) => trade.id) : [],
            phases: project.hasOwnProperty('phases') ? project.phases.map((phase) => phase.id) : [],
            pm_phases: project.hasOwnProperty('pmphases') ? project.pmphases.map((pmphase) => pmphase.id) : [],
            xprocesses: project.hasOwnProperty('xprocesses') ? project.xprocesses.map((xprocess) => xprocess.id) : [],
            users: project.hasOwnProperty('users') ? project.users.map((user) => user.id) : [],
            external_users: project.hasOwnProperty('external_users')
                ? project.external_users.map((user) => user.id)
                : [],
            ms_integration: project.ms_integration,
            ms_users: project.ms_integration ? project.ms_users : [],
        });
    }

    public update(project: Project) {
        return axios.post('/projects/update', {
            id: project.id,
            title: project.title,
            description: project.description,

            trades: project.hasOwnProperty('trades') ? project.trades.map((trade) => trade.id) : [],
            phases: project.hasOwnProperty('phases') ? project.phases.map((phase) => phase.id) : [],
            pm_phases: project.hasOwnProperty('pmphases') ? project.pmphases.map((pmphase) => pmphase.id) : [],
            x_processes: project.hasOwnProperty('xprocesses') ? project.xprocesses.map((xprocess) => xprocess.id) : [],
            users: project.hasOwnProperty('users') ? project.users.map((user) => user.id) : [],
            external_users: project.hasOwnProperty('external_users')
                ? project.external_users.map((user) => user.id)
                : [],
            ms_integration: project.ms_integration,
            ms_users: project.ms_integration ? project.ms_users : [],
        });
    }

    public isDuplicateName(name: string) {
        return axios.get('/projects/isDuplicateName', {
            params: {
                name,
            },
        });
    }

    public remove(project: Project) {
        return axios.post('/projects/remove', {
            id: project.id,
        });
    }
}

export const projectWebservice = new ProjectWebservice();
